import React from 'react';
import { useAccountStore } from '../../stores/accountStore';

export type TabKey = 'practice' | 'sat' | 'ap';

const TAB_LABELS: Record<TabKey, string> = {
  practice: 'Practice',
  sat: 'SAT',
  ap: 'AP',
};

interface TopTabsProps {
  active: TabKey;
  onChange: (tab: TabKey) => void;
}

/** 顶部 Tab：practice 恒显示；sat/ap 仅在订阅或开启 credit_unlock_enabled 时显示 */
export const TopTabs: React.FC<TopTabsProps> = ({ active, onChange }) => {
  const canSeeTab = useAccountStore((s) => s.canSeeTab);
  const account = useAccountStore((s) => s.account);

  // account 变化时重新计算可见 tab（依赖 account 触发重渲染）
  const tabs: TabKey[] = (['practice', 'sat', 'ap'] as TabKey[]).filter((t) => canSeeTab(t));
  void account;

  return (
    <div className="flex items-center gap-1 border-b border-primary-100 px-6 h-14 bg-white">
      {tabs.map((t) => (
        <button
          key={t}
          onClick={() => onChange(t)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
            active === t
              ? 'bg-primary-50 text-primary-700'
              : 'text-gray-500 hover:text-primary-600 hover:bg-primary-50/60'
          }`}
        >
          {TAB_LABELS[t]}
        </button>
      ))}
    </div>
  );
};
